import React, { useState } from 'react';

import classNames from 'classnames';
import css from './Accordion.css';

import arrowUp from '../../assets/icons/up-chevron.svg';
import arrowDown from '../../assets/icons/down-arrow.svg';
import { FormattedMessage } from 'react-intl';

const AccordionItem = props => {

  const {
    component,
    index,
    label,
    show,
  } = props;

  const [open, setOpen] = useState(show || false);

  const displayLabel = label ? (
    label
  ) : (
    <FormattedMessage id="Accordion.label" values={{ index: index + 1 }} />
  );

  const handleAccordionClick = () => {
      setOpen(!open);
  };

  return (
    <React.Fragment>
      <div className={css.accordion} onClick={handleAccordionClick}>
        <label>{displayLabel}</label>
        <img alt="arrow" src={open ? arrowUp : arrowDown} className={css.arrow} />
      </div>
      {open ? <div className={css.panel}>{component}</div> : null}
    </React.Fragment>
  );
};

const Accordion = props => {

  const {
    children,
    rootClassNames,
    className,
  } = props;

  const classes = classNames(rootClassNames || css.root, className);

  return (
    <div className={classes}>
      {children && React.Children.map(children, (child, index) => {
        if(!child) {
          return null;
        }

        const {
          show,
          label,
        } = child.props;

        return (
          <AccordionItem key={index} label={label} index={index} show={show} component={child} />
        );
      })}
    </div>
  );
};

export default Accordion;